'use strict';

import 'angular';


export default function() {
	return {
		require: '^form',
		link: postLink,
		scope: {
			data: '<',
			replace: '<',
		},
	}

	function postLink(scope, element, attrs, $form) {
		scope.$watch('data', proxy, true);
		attrs.$set('type', 'hidden');

		function proxy(data) {
			if (scope.replace) {
				$form.$rest.$data = data;
			} else {
				angular.merge($form.$rest.$data, data);
			}
		}
	}
}
